import React, { useEffect, useState } from 'react'
import './FaqEdit.css'
import { useLocation } from 'react-router-dom';
import { SlArrowDown } from "react-icons/sl";
import { CiEdit } from "react-icons/ci";
import { MdDelete } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import axios from 'axios';


export default function AddFaqModal({ isOpen, closeFAQModal, askQuestion, handleInputChange, handleAddFaq ,showSuccess,message,isLoading}) {
    const [show, setShow] = useState(false);
    return (
        <div className={`add-faq-modal ${isOpen ? 'show-modal' : ''}`} onClick={closeFAQModal}>
            <div className='add-faq-inner-modal' onClick={(e) => e.stopPropagation()}>
                <div className='faq-modal-head'>
                    <h3>Add FAQ</h3>
                    <button onClick={closeFAQModal} className='close-faq-modal'>
                        <IoClose size={20} color='#595959' />
                    </button>
                </div>

                <div className='faq-inputs'>
                    <input type='text' placeholder='Enter Question' name='question' value={askQuestion.question} onChange={handleInputChange} className='faq-input' />
                    <textarea placeholder='Enter Answer' rows={4} className='faq-answer-input' name='answer' value={askQuestion.answer} onChange={handleInputChange}></textarea>
                </div>
                <div className='faq-modal-btns'>
                    <button className='cancel_btn' onClick={closeFAQModal}>Cancel</button>
                    {isLoading ? <div style={{ borderTop: "4px solid var(--Dark-Blue)" }} className="btn-loader-Publish"></div> : <button onClick={handleAddFaq}>Save</button>}
                </div>

                <div className={`succes_drawer ${showSuccess ? 'show' : ''}`}>
                    
                    <h2 style={{ color: 'white' }}>Success</h2>
                    <p>{message}</p>
                    <button onClick={() => closeFAQModal()}>Okay</button>
                </div>

            </div>

        </div>

    )
}